module.exports = __webpack_public_path__ + "static/media/amb_main.a3296805.mp3";